<template>
  <div>
    <p>{{ label }} <strong>Epic Inbasket message</strong></p>
    <ul class="list-unstyled object-details">
      <li v-if="details.destination_type == 'Pool'">Inbasket Pool: {{ details.pool_id }}</li>
      <li v-else>Epic Users: {{ details.epic_usernames.join(', ') }}</li>
      <li>Status: {{ details.status }}</li>
      <li>Epic Message ID: {{ details.epic_message_id }}</li>
      <li>Message Type: {{ details.message_type }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "EpicInbasketMessage",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>